import { useEffect, useState } from 'react';
import { Button, Paragraph, Flex } from 'theme-ui';
import PropTypes from 'prop-types';
import { useCart, useCartCount, useCartCheckout } from '@backpackjs/storefront';

import { useCartStatus } from '@hooks';
import { Locale } from '@snippets';

import { Prices } from './Prices';
import { Discounts } from './Discounts';
import { themed } from './Totals.theme';

export const Totals = themed(
  ({ theme: themes, inSidebar = false, inputRef, ...props }) => {
    const cart = useCart();
    const cartCount = useCartCount();
    const { cartCheckout } = useCartCheckout();
    const [{ updatingCartStatus }] = useCartStatus();
    const [disabledCheckout, setDisabledCheckout] = useState(false);

    const theme = inSidebar ? themes.sidebar : themes.page;
    const cartAmount = cart?.estimatedCost?.subtotalAmount?.amount;

    const checkoutStatusUpdateHandler = (evt) => {
      if (evt.detail.disableCheckout === true) {
        setDisabledCheckout(true);
      } else {
        setDisabledCheckout(false);
      }
    }

    useEffect(() => {
      document.addEventListener(
        'cart:block-checkout',
        checkoutStatusUpdateHandler
      );
      return () => {
        document.removeEventListener(
          'cart:block-checkout',
          checkoutStatusUpdateHandler
        );
      }
    }, [])
    return cartCount > 0 ? (
      <Flex
        data-comp={Totals.displayName}
        {...props}
        ref={inputRef}
        sx={{
          ...props.sx,
          ...theme.wrapper,
        }}
      >
        <Paragraph sx={theme.summary}>Order Summary</Paragraph>

        {inSidebar && <Discounts />}

        {/* Checkout button */}
        <Button
          onClick={cartCheckout}
          disabled={updatingCartStatus.started || disabledCheckout}
          sx={theme.checkout}
          id="SidebarCartCheckout"
        >
          Checkout <span className="px-1">-</span>
          <Locale.CartTotals cart={cart} key={cartAmount}>
            <Locale.Price>
              {(propsLoc) => <Prices inSidebar={inSidebar} {...propsLoc} />}
            </Locale.Price>
          </Locale.CartTotals>
        </Button>
      </Flex>
    ) : null;
  }
);

Totals.displayName = 'CartTotals';
Totals.propTypes = {
  inSidebar: PropTypes.bool,
};
